










import { gql } from 'graphql-tag';
import { Component, mixins } from 'nuxt-property-decorator';

import { blockableBlockColorFragment, blockColorMixin } from '@/composables/block-color';

import { FileBlockDataFragment } from '@/graphql/generated';
import { PageBlockMixin } from '@/modules/cms';

@Component({
  graphqlData: gql`
    fragment FileBlockData on FileBlock {
      id
      title
      files {
        id
        title
        url
      }
      ...BlockColor
    }
    ${blockableBlockColorFragment}
  `,
})
export default class FileBlock extends mixins(PageBlockMixin<FileBlockDataFragment>(), blockColorMixin) {
}
